import { FC } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  FormHelperText,
} from "@mui/material";

interface StrategyOption {
  value: number;
  label: string;
}

interface StrategySelectorProps {
  label: string;
  icon?: React.ReactNode;
  value: number;
  options: StrategyOption[];
  description?: string;
  onChange: (value: number) => void;
  disabled?: boolean;
  className?: string;
}

const StrategySelector: FC<StrategySelectorProps> = ({
  label,
  icon,
  value,
  options,
  description,
  onChange,
  disabled = false,
  className = "",
}) => {
  return (
    <Box className={className}>
      <FormControl fullWidth disabled={disabled}>
        <InputLabel id={`strategy-select-${label}`}>
          {icon} {label}
        </InputLabel>
        <Select
          labelId={`strategy-select-${label}`}
          id={`strategy-select-input-${label}`}
          value={value}
          label={`${icon} ${label}`}
          onChange={e => onChange(Number(e.target.value))}
        >
          {options.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {description && <FormHelperText>{description}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default StrategySelector;
